import React from 'react'
import { Container, Headshot, TextGroup, MemberName, MemberPosition } from './teamMemberCardElements'
import './../../../pages/Execs.css'

export default class TeamMemberCard extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        let headshotStyle;
        switch(this.props.borderColor) {
            case "y":
                headshotStyle = {border: "3px solid #FEDB01"};
                break;
            case "b":
                headshotStyle = {border: "3px solid #143E82"};
                break;
            case "r":
                headshotStyle = {border: "3px solid #B21B39"};
                break;
        }
        return (
            <Container className="exec-prof">
                <Headshot src={this.props.pic} alt={this.props.name} style={headshotStyle}/>
                <TextGroup>
                    <MemberName>{this.props.name}</MemberName>
                    <MemberPosition>{this.props.position}</MemberPosition>
                </TextGroup>
            </Container>
        );
    }
}
